import { render, staticRenderFns } from "./MetricsCard.vue?vue&type=template&id=31767c54&"
import script from "./MetricsCard.vue?vue&type=script&lang=ts&"
export * from "./MetricsCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports